const theme = {
  colors: {
    primary: "#2A9D8F",
    // primary200: "#002244",
    primary200: "#225E77",
    secondary: "#FFF",

    textPrimary: "#505050",

    light100: "#fff",
    light200: "#fbfbff",
    light300: "#f7f7f7",
    light400: "#d8d8d8",
    light500: "#c4c4c4",

    dark400: "#7e7e7e",
    dark1000: "#000",
  },
};

export default theme;
